module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-3-en-US-8e110625fd358038d6afa763ab7af1cd.png";